const Images = {
    formBird: require('../assets/formBird.png'),
    logo: require('../assets/logo.png'),
    logo1: require('../assets/logo1.jpeg'),
    subBird: require('../assets/subBird.png'),
}

export default Images;